export default {
  backendValidationErrorMessage: 'Oups, une erreur s\'est produite. Voir plus bas.',
  backendValidationUnexpectedErrorMessage: 'Oups, une erreur s\'est produite.',
  saveButtonText: 'Enregistrer',
  cancelButtonText: 'Annuler',
};
